import React from 'react'
import { useTranslation } from 'react-i18next';
import AlertModal from '../../pages/Modals/AlertModal';

function ModalUELogin({open, user, onClose}) {
    const {t}=useTranslation();

    const message = !user.uecode
      ? <p>No UE login code is currently available. Please make sure to renew your demand on Earniverse Game Interface. For any issue, feel free to create a ticket on <a href='https://support.earniverse.io'>https://support.earniverse.io</a></p>
      : <p>{user.uecode}</p>;

  return (
    <AlertModal
      open={open}
      onClose={onClose}
      variant="info"
      message={message}
    />
  )
}

export default ModalUELogin;